"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTransition } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue, } from "@owlcat/ui";
/**
 * Shared header language switcher for the fleet. On select it (1) writes the
 * SHARED `owlcat-locale` cookie (parent-domain when on a subdomain, host-only on
 * bare localhost) so sibling apps inherit the choice on the next cross-app hop,
 * then (2) navigates to the same page under the new locale (or calls `onSelect`).
 * Anonymous-friendly — no auth, so it renders identically before and after login.
 */
export function LanguageSwitcher({ locale, locales, localeNames, parentDomain, label = "Language", onSelect, }) {
    const [, startTransition] = useTransition();
    function handle(next) {
        if (next === locale)
            return;
        if (typeof window !== "undefined") {
            const parent = parentDomain?.trim().replace(/^\.+/, "");
            const host = window.location.hostname;
            const onParent = !!parent && (host === parent || host.endsWith(`.${parent}`));
            const domain = onParent ? `; Domain=.${parent}` : "";
            const secure = window.location.protocol === "https:" ? "; Secure" : "";
            document.cookie = `owlcat-locale=${next}; Path=/; Max-Age=31536000; SameSite=Lax${domain}${secure}`;
        }
        if (onSelect) {
            onSelect(next);
            return;
        }
        startTransition(() => {
            const parts = window.location.pathname.split("/");
            parts[1] = next;
            const path = parts.join("/") || `/${next}/`;
            window.location.assign(path + window.location.search + window.location.hash);
        });
    }
    return (_jsxs(Select, { value: locale, onValueChange: handle, children: [_jsx(SelectTrigger, { size: "sm", "aria-label": label, className: "cursor-pointer gap-1.5", children: _jsx(SelectValue, { children: localeNames[locale] ?? locale }) }), _jsx(SelectContent, { children: locales.map((l) => (_jsx(SelectItem, { value: l, className: "cursor-pointer", children: localeNames[l] ?? l }, l))) })] }));
}
